import React from 'react';
import { connect } from 'react-redux';
import { getPreference, savePreference } from '../../../../../../Redux/Actions/EndUser/AccountPreferenceActions';
import { addInterestForMembership } from '../../../../../../Redux/Actions/EndUser/MembershipAction';
import { Button } from 'reactstrap';
import SpanSpinner from '../../../../../Shared/SpanSpinner/SpanSpinner';
import { withRouter } from 'react-router-dom';
import './InterestSignup.scss';

class InterestSignup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            newsletters: []
        }
    }

    componentDidMount() {
        if (this.props.membership.interests) {
            this.setState({
                newsletters: this.props.membership.interests
            });
        }
        else {
            this.props.getPreference(this.props.membership.userId);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        let t = this.state.newsletters;
        let t2 = this.props.newsletters;
        let t3 = this.props.membership.interests;
        if (prevProps.newsletters !== this.props.newsletters) {
            this.setState({ newsletters: this.props.newsletters });
        }
    }

    handleChange = (event) => {
        const target = event.target;
        var id = target.id.toString();
        var arr = this.state.newsletters.map(item => {
            return {
                id: item.id,
                title: item.title,
                selected: item.id.toString() === id ? target.checked : item.selected
            }
        })
        this.setState({ newsletters: arr });
    }

    update = (event) => {
        event.preventDefault();
        if (this.props.membership.userId) {
            this.props.addInterestForMembership(this.state.newsletters)
        }
        this.props.nextStep();
    }

    updateBack = (event) => {
        event.preventDefault();
        if (this.props.membership.userId) {
            this.props.addInterestForMembership(this.state.newsletters)
        }
        this.props.previousStep();
    }

    interestClick = (item) => {
        var id = item.id.toString();
        var arr = this.state.newsletters.map(item => {
            if (item.id.toString() === id) {
                return {
                    id: item.id,
                    title: item.title,
                    selected: !item.selected
                }
            } else {
                return {
                    id: item.id,
                    title: item.title,
                    selected: item.selected
                }

            }
        })
        this.setState({ newsletters: arr });
    }

    render() {
        return (
            <div className="interestSignupContainer">
                <div className="interestVH cols">
                    <div className="col-lg-7 interestSpacing col-left">
                        <h1 className="interestTitle pt-3 pb-3">Interests</h1>
                        <p>Tell us your interests, and we’ll send you invites, blog posts, and information.</p>
                        <div>
                            <p>Click to highlight anything that interests you! Click again to unhighlight.</p>
                            <ul className="interestContainer row">
                                {
                                    this.state.newsletters.map((item, index) => {
                                        return (
                                            <li className='col-md-4' onClick={() => this.interestClick(item)} key={index} className={item.selected ? 'selectedInterest interest' : 'interest'}>
                                                <div className="interest-text">
                                                    {item.title}
                                                </div>
                                            </li>
                                        )                                     
                                    })
                                }
                            </ul>
                        </div>
                        <div className="buttonContainer">
                            <button className="signUpBtns mb-3 btnPrimary" onClick={this.updateBack}>Back</button>
                            <button
                                color="primary"
                                className="signUpBtns mb-3 btnPrimary"
                                onClick={this.update}>
                                {
                                    this.props.updating
                                        ? <SpanSpinner message="Updating ..." />
                                        : "NEXT STEP"
                                }
                            </button>
                        </div>
                        
                    </div>
                    <div className="col-lg-5 interestBackground col-right">
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        membership: state.membership,
        newsletters: state.preference.newsletters
    }
}

export default withRouter(connect(mapStateToProps, { getPreference, savePreference, addInterestForMembership })(InterestSignup));